import React, { useEffect, useRef, useState } from "react";
import config from "../Config/config";
import axios from "axios";



export default function EbayConnect() {
    const [connected, setConnected] = useState(false);
    const [connecting, setConnecting] = useState(false);
    const [error, setError] = useState("");
    const popupRef = useRef(null);
    const pollRef = useRef(null);

    const userId = localStorage.getItem("userId") || "demo-user";

    // On mount, check if already connected
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                await axios.get(`${config.API_BASE_URL}/ebay/check-connection`, {
                    params: { userId },
                });
                if (!cancelled) setConnected(true);
            } catch {
                if (!cancelled) setConnected(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [userId]);

    const openPopup = (url) => {
        const w = 600, h = 700;
        const y = window.top.outerHeight / 2 + window.top.screenY - h / 2;
        const x = window.top.outerWidth / 2 + window.top.screenX - w / 2;
        const popup = window.open(
            url,
            "Connect eBay",
            `width=${w},height=${h},left=${x},top=${y},resizable,scrollbars`
        );
        popup?.focus?.();
        return popup;
    };

    const stopPolling = () => {
        if (pollRef.current) {
            window.clearInterval(pollRef.current);
            pollRef.current = null;
        }
    };

    const handleConnect = () => {
        setError("");
        setConnecting(true);
        const authUrl = new URL("https://auth.ebay.com/oauth2/authorize");

        authUrl.searchParams.set("client_id", "AnishaRa-Listerna-PRD-f81619b88-94b8bbff"); // PROD App ID
        authUrl.searchParams.set("response_type", "code");
        authUrl.searchParams.set("redirect_uri", "Anisha_Ramanuj-AnishaRa-Lister-mymcceavl"); // PROD RuName
        authUrl.searchParams.set("scope", [
            "https://api.ebay.com/oauth/api_scope/sell.inventory",
            "https://api.ebay.com/oauth/api_scope/sell.account"
        ].join(" "));
        authUrl.searchParams.set("state", "7iHbSKxuItPeD43MPqHRMsMN3Ff2");
        authUrl.searchParams.set("prompt", "login");
        // Pass state so we know which user this is
        authUrl.searchParams.set("state", userId);

        popupRef.current = openPopup(authUrl.toString());

        pollRef.current = window.setInterval(async () => {
            const closed = !popupRef.current || popupRef.current.closed;

            try {
                await axios.get(`${config.API_BASE_URL}/ebay/check-connection`, { params: { userId } });
                setConnected(true);
                setConnecting(false);
                stopPolling();
                try { popupRef.current?.close?.(); } catch { }
            } catch {
                if (closed) {
                    setConnecting(false);
                    setError("Login window closed before finishing. Try again.");
                    stopPolling();
                }
            }
        }, 1500);
    };
    // Cleanup popup + polling on unmount
    useEffect(() => {
        return () => {
            stopPolling();
            try { popupRef.current?.close?.(); } catch { }
        };
    }, []);

    return (
        <div>
            <h1>eBay Connection</h1>
            <p>{connected ? "✅ Connected to eBay" : "❌ Not connected"}</p>
            <button onClick={handleConnect} disabled={connecting}>
                {connecting ? "Connecting..." : connected ? "Reconnect" : "Connect eBay"}
            </button>
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
}